import moment from "moment";
import { Utils } from "../constants/utils";
import { routes } from "../mapping";
import { AVIVA_PARTNER_CODE, DBGB_PARTNER_CODE } from "../constants";
import { ONLY_DIGIT_FIELDS } from "../constants/field";
import { saveAs } from "file-saver";
import axios from "axios";

export const buildLeadPageUrl = () => {
  const url = process.env.REACT_APP_SITE_URL;
  let searchParams = "";

  if (getStorageItem("partnerCode") === DBGB_PARTNER_CODE) {
    searchParams = `partner=${getStorageItem(
      "partnerCode"
    )}&branch=${getStorageItem("partnerBranchCode")}`;
  }

  if (getStorageItem("partnerCode") === AVIVA_PARTNER_CODE) {
    searchParams = `partner=${getStorageItem(
      "partnerCode"
    )}&code=${getStorageItem("code")}`;
  }

  return searchParams ? `${url}?${searchParams}` : url;
};

export const buildSystemErrorMessage = () => {
  return {
    data: {
      error_msg:
        "It looks like something went wrong. Please try again in a while.",
    },
  };
};

export const calculateBMI = ({ weight, height }) => {
  if (weight <= 0 || height <= 0) {
    return 0;
  }

  let heightM = height / 100; // Convert height from cm to meters
  let bmi = weight / (heightM * heightM); // BMI calculation

  return bmi.toFixed(2); // Return BMI with 2 decimal places
};

export const capitalize = (word) =>
  word[0].toUpperCase() + word.slice(1).toLowerCase();

export const convertToAge = (dob) => {
  if (!dob) {
    return 0;
  }

  return moment().diff(dob, "years");
};

export const convertToAgeYearsMonthsDays = (dob) => {
  if (!dob) {
    return 0;
  }

  const now = moment();
  const birthDate = moment(dob);

  const years = now.diff(birthDate, "years");
  birthDate.add(years, "years");

  const months = now.diff(birthDate, "months");
  birthDate.add(months, "months");

  const days = now.diff(birthDate, "days");

  return `${years} years, ${months} months, ${days} days`;
};

export const convertDateToTime = ({ date }) => moment(date).format("HH:mm");

export const convertDateToString = ({ date }, format = "YYYY-MM-DD") =>
  moment(date).format(format);

export const detectMob = () => {
  let match = window.matchMedia || window.msMatchMedia;
  if (match) {
    let mq = match("(pointer:coarse)");
    return mq.matches;
  }
  return false;
};

export const detectMobile = () =>
  /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

export const downloadFile1 = async (url, filename) => {
  const blob = new Blob([url], {
    type: "application/pdf",
  });

  saveAs(blob, filename);
};

export const downloadFile = async (url, filename) => {
  try {
    const response = await axios.get(url, {
      responseType: "blob", // Important!
    });

    const blob = new Blob([response.data], { type: "application/pdf" });
    saveAs(blob, filename);
  } catch (error) {
    console.error("Error downloading the file:", error);
  }
};

export const extractFirstName = (name) => {
  if (!name) {
    return name;
  }

  return capitalize(name.split(" ")[0]);
};

export const feetAndInchesToCm = (feet, inches) => {
  if (!feet || inches === "") {
    return 0;
  }

  return parseInt(Math.round((feet * 30.48 + inches * 2.54).toFixed(2)), 10);
};

export const getRoute = (reference) => routes[reference];

export const getQueryStringParameterValue = (keyName) =>
  new URLSearchParams(window.location.search).get(keyName);

export const isAgentPortalHeaderVisible = () => {
  return true;
};

export const linkClickHandler = (keyname, history) => {
  Utils.redirectionUsingReactRouter.sections.indexOf(keyname) >= 0
    ? navigateToUrl(Utils.links[keyname], history)
    : redirectWithBlank(Utils.links[keyname]);
};

export const logout = () => localStorage.clear();

export const makeid = (length = 10) => {
  let result = "";
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
};

export const navigateToUrl = (url, history) => {
  history.push({
    pathname: url,
  });
};

export const parseBool = (str) => {
  if (str === null) return false;

  if (typeof str === "boolean") {
    return str === true;
  }

  if (typeof str === "string") {
    if (str === "") return false;

    str = str.replace(/^\s+|\s+$/g, "");
    if (str.toLowerCase() === "true" || str.toLowerCase() === "yes")
      return true;

    str = str.replace(/,/g, ".");
    str = str.replace(/^\s*\-\s*/g, "-");
  }

  if (!isNaN(str)) return parseFloat(str) !== 0;

  return false;
};

export const parseMessage = (message) => {
  if (typeof message === "string") {
    return message;
  } else if (Array.isArray(message) && message.length) {
    let errors = [];

    const output = message.map((item) => [...errors, item.msg]);

    return output.join(", ");
  } else {
    let errors = [];

    for (const [key, value] of Object.entries(message)) {
      errors.push(value);
    }

    return errors;
  }
};

export const redirectWithBlank = (url) => {
  var a = document.createElement("a");
  a.target = "_blank";
  a.href = url;
  a.click();
};

export const redirectWithImage = (url) => {
  let data = `${url}`;
  let w = window.open("about:blank");
  let image = new Image();
  image.src = data;
  setTimeout(function () {
    w.document.write(image.outerHTML);
  }, 0);
};

export const renderOTPTimer = (totalSeconds) => {
  totalSeconds %= 3600;

  let minutes = Math.floor(totalSeconds / 60);
  let seconds = totalSeconds % 60;

  // If you want strings with leading zeroes:
  minutes = String(minutes).padStart(2, "0");
  seconds = String(seconds).padStart(2, "0");

  return `${minutes} : ${seconds}`;
};

export const scrollTo = (id) => {
  const section = document.querySelector(`#${id}`);
  section.scrollIntoView({ behavior: "smooth", block: "center" });
};

export const scrollTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

export const toObject = (fields, value = "") => {
  const object = {};

  fields.forEach((field) => (object[field] = value));

  return object;
};

export const truncateString = (word = "") => {
  try {
    return word.length > 30 ? `${word.substring(0, 27)}...` : word;
  } catch (err) {
    return word;
  }
};

/*
export const clearBuyflowStorageData = () => {
  // Product Selection
  removeStorageItem("sumAssured");
  removeStorageItem("premium");

  // Customer Details
  removeStorageItem("generateOtp");
  removeStorageItem("verifyOtp");
  removeStorageItem("mobile");
  removeStorageItem("name");
  removeStorageItem("dob");
  removeStorageItem("gender");
  removeStorageItem("address");

  // Payment Details
  removeStorageItem("upi_id");

  // Nominee Details
  removeStorageItem("nominee_name");
  removeStorageItem("nominee_relationship");
  removeStorageItem("nominee_dob");

  // Customer Liveliness Check
  removeStorageItem("capturedImage");
};
*/

export const validateInputLength = (event) => {
  let elName = event.target.name;
  let elValue = event.target.value;

  if (ONLY_DIGIT_FIELDS.indexOf(event.target.name) > -1) {
    var clean = elValue.replace(/[^0-9]+/g, "");
    event.target.value = clean;
  }

  if (elValue.length > Utils.limit.digits[elName]) {
    event.target.value = elValue.substring(0, Utils.limit.digits[elName]);
  }
};

export const reBuildBankList = (banks = []) => {
  if (!banks.length) {
    return [];
  }

  banks.map((item) => {
    item.code = item.bank_code;
    item.label = item.bank_name;
  });

  return banks;
};

export const reBuildIFSCCodeList = (list = []) => {
  if (!list.length) {
    return [];
  }

  list.map((item) => {
    item.code = item.ifsc_code;
    item.label = item.ifsc_code;
  });

  return list;
};

export const reBuildMandateList = (mandates = []) => {
  if (!mandates.length) {
    return [];
  }

  mandates.map((item) => {
    item.code = item.name;
    item.label = item.name;
  });

  return mandates;
};

export const rebuildOccupationList = (data = []) => {
  if (!data.length) {
    return [];
  }

  data.map((item) => {
    item.label = item.description;
  });

  return data;
};

export const validateBankOfMaharashtraIFSC = (ifsc) => {
  const regex = /^MAHB0[A-Z0-9]{6}$/; // MAHB followed by '0' and 6 alphanumeric characters
  return regex.test(ifsc);
};

export const isValidIFSC = (ifsc) => {
  const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
  return ifscRegex.test(ifsc.toUpperCase());
};

export const extractBranchNameViaIFSCCode = (ifsc, list) => {
  const filteredData = list.filter((item) => item.ifsc_code === ifsc);

  if (filteredData?.length === 0) {
    return "";
  }

  return filteredData[0]?.branch_name;
};

/* Start Storage Methods */
export const getStorageItem = (key) => {
  var now = Date.now(),
    expiresIn = localStorage.getItem(key + "_expiresIn");

  if (expiresIn === undefined || expiresIn === null) {
    expiresIn = 0;
  }

  if (expiresIn < now) {
    // Expired
    removeStorageItem(key);
    return null;
  } else {
    try {
      var value = localStorage.getItem(key);
      return value;
    } catch (e) {
      console.log(
        "getStorage: Error reading key [" +
          key +
          "] from localStorage: " +
          JSON.stringify(e)
      );
      return null;
    }
  }
};

export const setStorageItem = (key, value, expires = null) => {
  if (expires === undefined || expires === null) {
    expires = 365 * 24 * 60 * 60; // default: seconds for 1 year
  } else {
    expires = Math.abs(1000 * expires);
  }

  var now = Date.now(),
    schedule = now + expires * 1000;

  try {
    localStorage.setItem(key, value);
    localStorage.setItem(key + "_expiresIn", schedule);
  } catch (e) {
    console.log(
      "setStorage: Error setting key [" +
        key +
        "] in localStorage: " +
        JSON.stringify(e)
    );
    return false;
  }
  return true;
};

export const removeStorageItem = (key) => {
  try {
    localStorage.removeItem(key);
    localStorage.removeItem(key + "_expiresIn");
  } catch (e) {
    console.log(
      "removeStorage: Error removing key [" +
        key +
        "] from localStorage: " +
        JSON.stringify(e)
    );
    return false;
  }
  return true;
};

export const removeAllStorageItem = (list) => {
  for (let i of list) {
    removeStorageItem(i);
  }
};

export const clearStorageItem = () => {
  localStorage.clear();
};
/* End Storage Methods */
